import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { IUserProfile } from "../../../../models/UserProfile";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (
  organizationId: string,
  registerDemo: boolean,
  userSignUp: IUserProfile
) => {
  const payload = {
    body: userSignUp,
  };

  if (registerDemo) {
    return API.post(APIEndpoints.public, "/api/v1/public/register", payload);
  } else {
    return API.post(
      APIEndpoints.public,
      `/api/v1/public/register/${organizationId}`,
      payload
    );
  }
};

export const useCreateUserProfile = () => {
  const queryClient = useQueryClient();

  return useMutation<
    IUserProfile,
    AxiosError,
    {
      organizationId: string;
      registerDemo: boolean;
      userSignUp: IUserProfile;
    }
  >(
    ({ organizationId, registerDemo, userSignUp }) =>
      makeApiRequest(organizationId, registerDemo, userSignUp),
    {
      retry: 0,
      onSettled: () => {
        queryClient.invalidateQueries(QueryKeys.userProfiles(), {
          exact: false,
        });
      },
    }
  );
};
